module.exports = __webpack_public_path__ + "img/DP158.c627525f.jpg";